import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { TrackData } from '../../types';
import { TrackRepository } from '../shared-repositories';
import type { TrackService } from '../track-service';

@injectable()
export class TrackServiceImpl implements TrackService {
    constructor(
        @inject(TrackRepository) private trackRepository: TrackRepository
    ) {
    }

    trackAir(data: TrackData) {
        return this.trackRepository.track(data);
    }

    trackSeek(data: TrackData) {
        return this.trackRepository.track({
            event_type: 'SS Seek Search',
            source_type: 'seek',
            ...data,
        });
    }
}
